import _            from 'underscore';
import { useState } from 'react';

import { UseStateHookFunction } from '../../types';
import { Charting }             from '../../types/charting';
import { ChartType }            from 'chart.js';

export type UseChartReportingExportHook = {
	hasExportControls: boolean,
};

export function useChartReportingExport<T extends ChartType>( chartReportProps: ( Charting.Reporting.ChartReportBaseProps<T> & Charting.Reporting.ChartReportingExportProps<T> ) ): UseChartReportingExportHook{
	
	const hasExportControls = !_.isEmpty(
		_.compact( [
			chartReportProps.enableImageDownload,
			chartReportProps.enableCSVDownload,
			chartReportProps.enableCopyDataText,
		] )
	);
	
	return {
		hasExportControls,
		
	} as UseChartReportingExportHook;
}
